import React, { useCallback, useState } from "react";

import { useUserActivityCreatedListener, useNotificationReceivedListener } from "app/hooks";
import { Trans } from "app/utils";
import { isForEveryone } from "app/context/useUnseen";
import notificationsTypes from "constants/notificationsTypes";

import FeedItem from "./FeedItem";


const FeedUpdates = ({ forYou, onNotificationClicked }) => {
  const [{ active, inactive }, setState] = useState({ active: [], inactive: [] });

  useNotificationReceivedListener(
    useCallback(
      notification => {
        switch (notification.notificationType) {
          case notificationsTypes.PRIVATE_EVENT:
            setState(current => ({
              active: current.active,
              inactive: [notification.entity, ...current.inactive]
            }));
            break;
          case notificationsTypes.FOR_YOU:
            setState(current => ({
              active: current.active,
              inactive: [notification.entity, ...current.inactive]
            }));
            break;
          case notificationsTypes.NOT_FOR_YOU:
            if (!forYou) {
              setState(current => ({
                active: current.active,
                inactive: [notification.entity, ...current.inactive]
              }));
            }
            break;
          default:
            break;
        }
      },
      [forYou, setState]
    )
  );

  useUserActivityCreatedListener(
    useCallback(
      activity => {
        if (!forYou || isForEveryone(activity)) {
          setState(current => ({
            active: current.active,
            inactive: [activity, ...current.inactive.filter(
              prevActivity => prevActivity.id !== activity.id
            )]
          }));
        }
      },
      [forYou, setState]
    )
  );

  const onClick = useCallback(
    () => {
      onNotificationClicked(inactive);
      const ids = inactive.filter(activity => (
        activity.childUserActivities.length > 0
      )).map(actity => actity.id);
      setState(current => ({
        active: [...current.inactive, ...current.active.filter(
          activity => (!ids.includes(activity.id)))],
        inactive: []
      }));
    },
    [setState, onNotificationClicked, inactive]
  );

  const onUserActivityUpdate = useCallback(
    (activityId, updates) => setState(current => ({
      active: current.active.map(activity => (
        activity.id === activityId ? { ...activity, ...updates } : activity
      )),
      inactive: current.inactive
    })),
    [setState]
  );

  const onUserActivityRemove = useCallback(
    activityId => setState(current => ({
      active: current.active.filter(activity => activity.id !== activityId),
      inactive: current.inactive
    })),
    [setState]
  );

  return (
    <>
      {inactive.length > 0 && (
        <div className="NewContent box-shadow" onClick={onClick}>
          <p role="alert">
            {
              inactive.length === 1
                ? <Trans>See 1 new activity</Trans>
                : <Trans>See {inactive.length} new activities</Trans>
            }
          </p>
        </div>
      )}

      {active.map(activity => (
        <FeedItem
          key={activity.id}
          item={activity}
          onUserActivityUpdate={onUserActivityUpdate}
          onUserActivityRemove={onUserActivityRemove}
          animateIn
        />
      ))}
    </>
  );
};

export default FeedUpdates;
